"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchSelect = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Option = require("./Option");
var _SingleValue = require("./SingleValue");
var _DropdownIndicator = require("./components/DropdownIndicator");
var _ClearIndicator = require("./components/ClearIndicator");
var _CustomControl = require("./CustomControl");
var _NoOptionsMessage = require("./components/NoOptionsMessage");
var _styles = require("./styles");
var _excluded = ["value", "defaultValue", "isSearchable", "isClearable", "options", "placeholder", "noOptionsMessage", "onBlur", "onFocus", "filterOption", "onChange", "onInputChange", "customStyles", "closeMenuOnSelect", "menuIsOpen", "inputValue", "CustomControl", "CustomOption", "CustomSingleValue", "CustomDropdownIndicator", "CustomNoOptionsMessage", "isMobile"]; // Default select components:
// Styled:
var SearchSelect = exports.SearchSelect = function SearchSelect(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? {
      label: '',
      value: ''
    } : _props$value,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? {
      label: '',
      value: ''
    } : _props$defaultValue,
    isSearchable = props.isSearchable,
    isClearable = props.isClearable,
    options = props.options,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Выберите...' : _props$placeholder,
    _props$noOptionsMessa = props.noOptionsMessage,
    noOptionsMessage = _props$noOptionsMessa === void 0 ? function () {
      return 'Не найдено';
    } : _props$noOptionsMessa,
    _props$onBlur = props.onBlur,
    onBlur = _props$onBlur === void 0 ? function () {
      return undefined;
    } : _props$onBlur,
    _props$onFocus = props.onFocus,
    onFocus = _props$onFocus === void 0 ? function () {
      return undefined;
    } : _props$onFocus,
    filterOption = props.filterOption,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function (val) {
      return val;
    } : _props$onChange,
    _props$onInputChange = props.onInputChange,
    onInputChange = _props$onInputChange === void 0 ? function () {
      return undefined;
    } : _props$onInputChange,
    _props$customStyles = props.customStyles,
    customStyles = _props$customStyles === void 0 ? {} : _props$customStyles,
    _props$closeMenuOnSel = props.closeMenuOnSelect,
    closeMenuOnSelect = _props$closeMenuOnSel === void 0 ? true : _props$closeMenuOnSel,
    menuIsOpen = props.menuIsOpen,
    inputValue = props.inputValue,
    CustomControl = props.CustomControl,
    CustomOption = props.CustomOption,
    CustomSingleValue = props.CustomSingleValue,
    CustomDropdownIndicator = props.CustomDropdownIndicator,
    CustomNoOptionsMessage = props.CustomNoOptionsMessage,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var styles = (0, _styles.getStyles)(customStyles, isMobile);
  var components = {
    ClearIndicator: _ClearIndicator.ClearIndicator,
    DropdownIndicator: CustomDropdownIndicator || _DropdownIndicator.DropdownIndicator,
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    Option: CustomOption || _Option.Option,
    SingleValue: CustomSingleValue || _SingleValue.SingleValue,
    NoOptionsMessage: CustomNoOptionsMessage || _NoOptionsMessage.NoOptionsMessage,
    Control: CustomControl || _CustomControl.Control
  };
  return /*#__PURE__*/_react["default"].createElement(StyledSelect
  // Values:
  , (0, _extends2["default"])({
    defaultValue: defaultValue,
    value: value
    // Flags:
    ,
    isSearchable: isSearchable,
    isClearable: isClearable,
    closeMenuOnSelect: closeMenuOnSelect
    // Options:
    ,
    options: options,
    noOptionsMessage: noOptionsMessage,
    filterOption: filterOption
    // Custom styled and components:
    ,
    styles: styles,
    components: components,
    placeholder: placeholder
    // Controlled input:
    ,
    menuIsOpen: menuIsOpen,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur,
    inputValue: inputValue,
    onInputChange: onInputChange,
    classNamePrefix: "react-select"
  }, otherProps));
};
var StyledSelect = (0, _styledComponents["default"])(_reactSelect["default"]).withConfig({
  displayName: "SearchSelect__StyledSelect",
  componentId: "sc-1ukg8np-0"
})(["width:100%;"]);